import React from 'react'
// import { QueryClient } from 'react-query'
// import { dehydrate } from 'react-query/hydration'
// import { GetServerSidePropsContext } from 'next'
import { useRouter } from 'next/router'
import * as queryString from 'query-string'
// import { decodeQueryParams } from 'use-query-params'
// import { removeEmptyFieldObject } from '@plandi/common'

import {
  MainLayout,
  MainLayoutContent,
  MainLayoutSidebar
} from 'src/features/layouts'
import {
  ModelCard,
  // modelKeys,
  // modelsApi,
  useModelsFilters,
  useQueryModelsByUserId
} from '../../../features/models/common'
import { Button, Grid, useMediaQuery } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'
import { useModelStyles } from '../../../features/models/common/model.styles'
import { BreadCrumbs } from 'src/features/breadcrumbs/breadcrumbs'
import { SERVICES_URL, theme, useTranslation } from '@plandi/common'
import { GetServerSideProps, GetServerSidePropsContext } from 'next'
import { QueryClient } from 'react-query'
import { sharedApi, TRANSLATE } from '../../../shared'
import { dehydrate } from 'react-query/hydration'
import { ProfileDetails } from 'src/features/profile-details'
// import { ProjectListUserFiltersQueryParamConfigMap } from 'src/features/models'

// export const getServerSideProps = async ({
//   query
// }: GetServerSidePropsContext) => {
//   const queryClient = new QueryClient()

//   const { userId } = removeEmptyFieldObject(
//     decodeQueryParams(ProjectListUserFiltersQueryParamConfigMap, query)
//   )

//   if (userId) {
//     await queryClient.prefetchQuery(
//       modelKeys.user(userId as number, { page: query.page }),
//       () =>
//         modelsApi.getModelsByUserId({ userId, page: Number(query.page) || 1 })
//     )
//   }

//   return {
//     props: {
//       dehydratedState: dehydrate(queryClient)
//     }
//   }
// }

const ProjectsUserPage = (props: { locale: string }) => {
  const classes = useModelStyles()
  const router = useRouter()
  const userId = router.query.userId ? Number(router.query.userId) : undefined
  const isDesktop = useMediaQuery(theme.breakpoints.up(960))
  const { data: translate } = useTranslation()

  const { page } = useModelsFilters()
  const { data: projectsUser, isLoading } = useQueryModelsByUserId(
    userId,
    page,
    { page }
  )
  const items = projectsUser?.items || []
  const pageTotal = projectsUser?.pageTotal

  const handlerMorePage = (
    event: React.ChangeEvent<unknown>,
    pageValue: number
  ) => {
    const objQuery = queryString.parse(router.asPath.split(/\?/)[1])
    router.push(
      {
        pathname: '/models/users/[userId]',
        query: { ...objQuery, page: pageValue, userId: router.query.userId }
      },
      undefined,
      { scroll: true }
    )
  }

  const url = SERVICES_URL
  const locale = props.locale

  return (
    <MainLayout withFooter title={translate?.shop['user-projects']}>
      <div>
        <BreadCrumbs
          breadcrumbInfo={[
            {
              title: translate?.market.title,
              href: locale === 'ru' ? `${url.shop}/ru` : url.shop
            },
            {
              title: translate?.models,
              href: locale === 'ru' ? `${url.shop}/ru` : url.shop
            },
            { title: `${projectsUser?.contactData?.fullName}`, href: '' }
          ]}
        />
        <div style={isDesktop ? { display: 'flex' } : {}}>
          {(projectsUser?.contactData || isLoading) && (
            <MainLayoutSidebar size="large">
              <ProfileDetails
                userPage
                projectsProfile={projectsUser?.profile}
                loadingProfile={isLoading}
              />
            </MainLayoutSidebar>
          )}
          <MainLayoutContent>
            {/* <Toolbar className={classes.toolbarModelAuthor} /> */}
            <Grid container spacing={2}>
              {items.map((project) => (
                <Grid item xs={12} sm={6} md={6} lg={4} key={project.id}>
                  <ModelCard {...project} />
                </Grid>
              ))}
              {pageTotal ? (
                <>
                  <Grid item xs={12} sm={9} md={9} lg={10}>
                    <div className={classes.paginationBlockAuthor}>
                      <Pagination
                        count={pageTotal}
                        hidden={pageTotal < 2}
                        onChange={handlerMorePage}
                        showFirstButton
                        showLastButton
                        size={'medium'}
                        page={Number(router.query.page) || 1}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={2}>
                    <div className={classes.btnMoreModelBlock}>
                      <Button
                        className={classes.btnMoreModel}
                        onClick={() => router.push('/models')}
                      >
                        {translate?.shop['all-models']}
                      </Button>
                    </div>
                  </Grid>
                </>
              ) : null}
            </Grid>
          </MainLayoutContent>
        </div>
      </div>
    </MainLayout>
  )
}

export default ProjectsUserPage

export const getServerSideProps: GetServerSideProps = async ({
  locale
}: GetServerSidePropsContext) => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(TRANSLATE, () =>
    sharedApi.getTranslate(locale)
  )

  return {
    props: {
      locale: locale,
      dehydratedState: dehydrate(queryClient)
    }
  }
}
